import React from 'react';
import './LandingPage.css';
import { api_host } from '../apiClient';
import nsfLogo from '../assets/nsf.svg';
import spectrumxLogo from '../assets/spectrumx-rev.svg';
import MapContainer from '../components/MapContainer';

const LandingPage = () => {
  const handleLogin = () => {
    window.location.href = `${api_host}/accounts/login/`;
  };

  return (
    <div className="landing-page">
      <header className="landing-header">
        <nav className="navbar">
          <div className="container">
            <span className="navbar-brand">SigCap Data Platform</span>
            <button className="btn btn-primary" onClick={handleLogin}>
              Login / Sign Up
            </button>
          </div>
        </nav>
        <div className="hero-section hero-option-1">
          <div className="hero-background"></div>
          <div className="container">
            <h1>Understand and Map Wireless Signal Coverage</h1>
            <p className="lead">
              SigCap is a data platform for wireless research, powered by an
              Android application that captures GPS coordinates along with
              detailed cellular and Wi-Fi metrics. With over 15 million data
              points and growing, our platform provides granular insights for
              city planning, digital equity initiatives, and infrastructure
              development.
            </p>
            <button className="btn btn-secondary" onClick={handleLogin}>
              Get Started
            </button>
          </div>
        </div>
      </header>

      <main>
        <section className="features-section text-center">
          <div className="container">
            <h2>Platform Features</h2>
            <p
              className="lead"
              style={{ maxWidth: '800px', margin: '0 auto 3rem auto' }}
            >
              Our platform is built for researchers, city planners, and anyone
              interested in understanding wireless networks. We provide the
              tools to collect, analyze, and share network signal strength data
              at a granular level.
            </p>
            <div className="row">
              <div className="col-md-4">
                <div className="feature">
                  <h3>Web-Based Dataset Repository</h3>
                  <p>
                    Access a growing collection of over 15 million captured data
                    points through a user-friendly web interface.
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="feature">
                  <h3>Dynamic Visualizations</h3>
                  <p>
                    Analyze and explore network signal strength with our
                    interactive mapping and visualization tools.
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="feature">
                  <h3>Embeddable Maps</h3>
                  <p>
                    Easily share your findings and disseminate research with
                    embeddable, interactive maps.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="maps-section">
          <div className="container">
            <h2 className="text-center">Interactive Exhibits</h2>
            <p className="text-center">
              Explore live data from our two regions of focus. Pan and zoom to
              see signal strength in detail.
            </p>
          </div>
          <div className="map-exhibit">
            <div className="container">
              <h3>Exhibit 1: San Francisco Bay Area Cellular Coverage</h3>
              <p>
                This exhibit showcases the granular network signal strength data
                collected in the San Francisco Bay Area since January 1, 2024.
                The visualization highlights coverage across this dense urban
                environment, providing key insights for infrastructure planning
                and digital equity analysis.
              </p>
            </div>
            <div className="map-container-full-width">
              <MapContainer
                selectedRows={'0615b,16ece,199a1,1a1d1,1f7d3,21289,22f5a,255c3,2fbe9,38f88,3e343,40e41,441ad,445e0,48969,4bfcf,51462,5204f,5d712,61ac1,66c05,6a6c9,6e02a,6e66b,78e1b,80df2,89a5a,956c5,96138,9b865,a030d,a703c,aa5b4,ae23a,afe3f,b285b,bffef,c249e,c5c55,c84c9,c94e9,cd775,d1227,d6a88,dada9,ded6e,e2b2a,e5fb8,ec38a,f5391,fcaae'.split(
                  ',',
                )}
                geopolygon={[
                  [-122.59057633440604, 37.77398477873655],
                  [-122.20801176428185, 37.94550545785832],
                  [-121.88430328186897, 37.832797766935826],
                  [-121.73283540908213, 37.31350084431446],
                  [-121.84574710947399, 37.21773026742764],
                  [-122.05607106997213, 37.22255492704049],
                  [-122.46287049974234, 37.53549518879302],
                  [-122.59057633440604, 37.77398477873655],
                ]}
                selectedNetworkType="cellular"
                statistic="mean"
                technology="lte"
                band="all"
                binSize="250"
                baseLayer="light"
                center={[37.304139212582086, -121.9858637139481]}
                zoom={10.918425877611782}
                preventInitialFit={true}
                width="100%"
                height="800px"
                isEmbedded={true}
                showTechnologyControl={true}
                showBandControl={true}
                showStatisticControl={false}
              />
            </div>
          </div>
          <div className="map-exhibit">
            <div className="container">
              <h3>Exhibit 2: University of Notre Dame 6 GHz Wi-Fi Testbed</h3>
              <p>
                Explore a dense Wi-Fi 6E deployment at the University of Notre
                Dame, a real-world testbed for 6 GHz spectrum sharing. The data,
                collected via the SigCap Android app, provides crucial insights
                into how next-generation wireless technologies perform in a live
                environment. This research, funded by the NSF, helps pave the
                way for smarter, more efficient networks for everyone.
              </p>
            </div>
            <div className="map-container-full-width">
              <MapContainer
                selectedRows={'10592,11899,13762,19100,22627,26589,40278,41169,46683,48517,62245,74980,77246,87554,87676,93151,98041,98467,bfd1d,f04eb,dab4f,a8189,9273b,19b3f,2026b,b3ad8,587cc,00da5,b0bd9,fbbed,d5983,c482d,3701f,dc91b,3ae24,ba016,88a76,a4eb3,ea209,a2ca9,73f52,de000,14d36,bec1f,a3aaa,f435d,67ee2,619f2,c3f23,242e1,1a634,bf72a,c6265,0445e,b08f8,ed7b8,a7846,2f126,c81cf,e0b53,82cb1,570a4,28a14,207ab,159e3,5cded,750ba,1ee14,4d6fd,c7ad8,8a42a,063b2,e345c,2e27e,045a3,902a7,57d97,f1d0a,0b6da,78c62,bf2ed,f3144,be9f4,0c978,a398e,7e01a,5d529,9565d,4a7e4,f10bd,a923f,4b696,200d4,79fba,b3d0f,9ce97,9f1f4,cf5a2,fcaa8,2ed6e,f0630,46f92,20fd4,d29ba,dce0e,ee2ae,853fb,cb832,589f9,e42f2,a8646,6b486,8b9a6,7486a,c09e9,a3ad2,ee86c,9a40c,4ecc2,8a784,7b490,16f8e,fa3af,9c1ca,024e4,9f33e,dcbf9,ae134,70f8c,8d662,127c1,7f8fa,cdbff,fb79b,74ccc,9bacc,583c7,976f6,e74c2,741f8,303ad,ee93c,926f0,00a32,af494,1c107,a8cab,9cdfc,fbdbd,7e3f1,02a47,929ec,5cdb6,eb76d,0fa09,068a3,ceb33,d23f5,78f4d,4b9f6,a7330,4cd35,636ea,c2328,4f9ed,82af6,99be0,0a041,c76b3,422d3,1e602,6967a,c7439,ec9b8,e0321,b263d,3fdf1,a0a78,570a4,106a5,59fe3,e480d,f4a3e,f1dbc,10f48,748ee,56fc2,04d87,57f9a,7a248,b2311,380b6,6d3c5,b782f,ba80d,39e8d,8d5ee,ef7e5,a0f14,621a8,d3e46,d7f13,62ad0,f378b,2a19c,3a5df,210b1,a4cd0,60a6a,b85e8,42eb1,5d808,db04f,34d37,0b954,352b9,d9410,76f86,a5bcf,0449c,5b11b,3e0b0,2b3f3,8aeb5,bdddc3,0d63a,1ce5c,d0736,5bc7c,d27df,f54ba,5d7b4,1762f,45ddc,b5089,f1a3c,c24f8,4a0b5,556fe,e5bab,4d710,83ea3,2444a,f8950,5456a,a31ef,324f2,4b26a,3f052,bb751,fc176,6c3ecf,0c579,ebbf3,78a93,1c266,14f36,8e111,c13f0,a12cb,f0bed,26f07'.split(
                  ',',
                )}
                selectedNetworkType="wifi"
                statistic="mean"
                technology="6"
                band="all"
                binSize="1"
                baseLayer="satellite"
                center={[41.697981077172585, -86.23431126428702]}
                zoom={18}
                tilt={58.04083529712076}
                bearing={45.51323593093207}
                preventInitialFit={true}
                width="100%"
                height="800px"
                isEmbedded={true}
                showOperatorControl={false}
                showTechnologyControl={false}
                showBandControl={false}
                showStatisticControl={false}
                showBinSizeControl={false}
              />
            </div>
          </div>
        </section>

        <section className="publications-section">
          <div className="container">
            <h2 className="text-center">Research and Documentation</h2>
            <p
              className="lead text-center"
              style={{ maxWidth: '800px', margin: '0 auto 3rem auto' }}
            >
              Our platform is built for researchers and academics. The following
              resources are available to help you get started with the SigCap
              platform and to provide guidance on citing our work in your
              publications.
            </p>
            <div className="row">
              <div className="col-md-6">
                <div className="publication-card">
                  <h3>Technical Documentation</h3>
                  <p>
                    For detailed information on how SigCap works, including an
                    explanation of captured fields, please refer to our{' '}
                    <a
                      href="https://people.cs.uchicago.edu/~muhiqbalcr/sigcap/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      documentation
                    </a>
                    .
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="publication-card">
                  <h3>Citing in Publications</h3>
                  <p>
                    If you use SigCap in your research, please use the following
                    citation:
                  </p>
                  <p>
                    <strong>
                      Spectrum Sharing Characterization Using Smartphones:
                      Exploring 6 GHz Sharing Through Large-Scale Wi-Fi 6E
                      Measurements
                    </strong>
                    <br />
                    <em>
                      S. Doğan-Tusha, A. Tusha, M.I. Rochman, H. Nasiri, and M.
                      Ghosh, in IEEE Communications Magazine, 63(2), pp.70-76.
                    </em>
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="publication-card cta-card">
                  <h3>Get the SigCap App</h3>
                  <p>
                    Contribute to our dataset and measure network signal
                    strength on the go. Available for Android devices.
                  </p>
                  <a
                    href="https://appdistribution.firebase.dev/i/abc35a94d3640002"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary"
                  >
                    Download Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="landing-footer">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-logos">
              <img src={nsfLogo} alt="NSF Logo" />
              <img src={spectrumxLogo} alt="SpectrumX Logo" />
            </div>
            <div className="footer-text">
              <p>
                SigCap Data Platform is funded in part by{' '}
                <a
                  href="https://spectrumx.org"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  SpectrumX
                </a>
                , an NSF Spectrum Innovation Center funded via Award 2132700
                operated under cooperative agreement by the University of Notre
                Dame.
              </p>
            </div>
            <div className="footer-contact">
              <h3>Contact</h3>
              <p>For inquiries, please email us at sigcap-list@nd.edu.</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
